import { useState } from "react";
import type { Dialog } from "@/types/dialog";

interface NotesSectionProps {
  dialog: Dialog;
}

const NOTES_LANGUAGES: Record<string, string> = {
  en: "English",
  ru: "Русский",
  fr: "Français",
  es: "Español",
  ar: "العربية",
  ko: "한국어",
  ja: "日本語",
  "zh-TW": "中文",
  zh: "中文",
  cmn: "中文",
  th: "ไทย",
};

function findTranslation(translations: Record<string, string>, code: string): string | undefined {
  return translations[code]
    ?? translations[code.toLowerCase()]
    ?? translations[code.replace("-", "_")];
}

export function NotesSection({ dialog }: NotesSectionProps) {
  const [lang, setLang] = useState("en");
  const translations = dialog.notes_translations ?? {};

  if (!dialog.notes_en && Object.keys(translations).length === 0) return null;

  const availableLangs = ["en", ...Object.keys(translations).filter((k) => translations[k])];
  const activeText = lang === "en"
    ? dialog.notes_en
    : findTranslation(translations, lang) ?? dialog.notes_en;

  return (
    <div className="bg-th-surface-dim rounded-xl border border-th-border p-6 shadow-xl mt-6" translate="no">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm text-th-text-3 font-semibold uppercase tracking-wider">Notes</h3>
        {availableLangs.length > 1 && (
          <select
            className="bg-th-input border border-th-border rounded-lg px-2.5 py-1 text-xs text-th-text"
            value={lang}
            onChange={(e) => setLang(e.target.value)}
          >
            {availableLangs.map((code) => (
              <option key={code} value={code}>
                {NOTES_LANGUAGES[code] ?? code}
              </option>
            ))}
          </select>
        )}
      </div>
      <div className="text-th-text-2 text-sm leading-relaxed whitespace-pre-wrap">
        {activeText}
      </div>
    </div>
  );
}
